import type { ReactNode } from 'react'

export interface FieldProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  icon?: ReactNode
  type?: string
  optional?: boolean
  /** Optionaler Hinweistext unter dem Feld. */
  hint?: string
  /** Optionaler Fehlertext; markiert das Feld zusätzlich als aria-invalid. */
  error?: string
}

/** Einzelnes Formularfeld (Label + Control + optionaler Hinweis/Fehlertext) —
 *  BMC-Designsystem `console.css`. Optionales Lead-Icon links im Label. */
export function Field({ id, label, value, onChange, icon, type = 'text', optional, hint, error }: FieldProps) {
  const inputId = `f_${id}`
  return (
    <div className="field">
      <label className="flabel" htmlFor={inputId}>
        {icon && <span className="inline-flex">{icon}</span>}
        {label}
        {optional && <span className="opt">(optional)</span>}
      </label>
      <input
        className="inp"
        id={inputId}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={error ? true : undefined}
      />
      {hint && <span className="fhint">{hint}</span>}
      {error && <span className="ferror">{error}</span>}
    </div>
  )
}
